import billingRepository from '@/repository/billingRepository';
import * as constants from '@/common/constants';
import {
  log
} from '@/logging';
const state = {
  billingInfo: {},
  billingAccountsSummaryElements: [],
  selectedBillingAccountsElements: [],
  overDueTotal: 0,
  curtain: {}
};
const actions = {
  createCurtainActive({
    commit
  }, {
    activa,
    txtError,
    tituloMigrado,
    txtMigrado,
    tituloNoMigrado,
    txtNoMigrado
  }) {
    commit('createCurtainActive', {
        activa: activa,
        txtError: txtError,
        tituloMigrado: tituloMigrado,
        txtMigrado: txtMigrado,
        tituloNoMigrado: tituloNoMigrado,
        txtNoMigrado: txtNoMigrado
    });
  },
  createBillingInfo({
    commit
  }, {
    customerIdentificationNumber,
    email,
    paymentType,
    paymentChannel,
    context,
    homeUrl,
    muestraVencido,
    metadata
  }) {
    commit('createBillingInfo', {
      customerIdentificationNumber: customerIdentificationNumber,
      email: email,
      paymentType: paymentType,
      paymentChannel: paymentChannel,
      context: context,
      homeUrl: homeUrl,
      muestraVencido: muestraVencido,
      metadata: metadata,
      touch: constants.touch[paymentChannel]
    });
  },
  createSelectedBillingAccountsElements({
    commit
  }) {
    commit('createSelectedBillingAccountsElements');
  },
  async updateBillingInfo({
    commit,
    state
  }, {
    sessionId
  }) {
    let billingInfo = state.billingInfo;
    billingInfo.paymentType = state.billingInfo.paymentType
    billingInfo.usuarioMovil = false;
    billingInfo.rutSinDeuda = true;
    billingInfo.cuentaConDeuda = false;
    billingInfo.statusOk = false;
    billingInfo.hogarTango = false;
    billingInfo.pufConDispositivo = false;
    billingInfo.pufSinDispoitivo = false;

    if(billingInfo.metadata.sessionId !== undefined){
      sessionId = billingInfo.metadata.sessionId;
    }

    if (
      billingInfo !== undefined &&
      sessionId !== undefined
    ) {

      const billingAccountsRequest = await billingRepository.getBillingAccounts(sessionId);
      billingInfo.statusOk = (billingAccountsRequest.status == 200) ? true : false;
      const billingAccounts = billingAccountsRequest.data.data;
      let customer = billingAccounts.customer;
      billingInfo.customerFullName = customer ? [customer.firstName ? customer.firstName : "", customer.lastName ? customer.lastName : "", customer.mothersMaidenName ? customer.mothersMaidenName : ""].join(" ") : "";
      if (billingInfo.customerEmail !== null && billingInfo.customerEmail !== undefined && billingInfo.customerEmail.length > 0) {
        billingInfo.customerEmail = customer.email;
      }
      if (billingAccounts.billingAccounts) {
        for (var k = 0; k < billingAccounts.billingAccounts.length; k++) {
          for (var i = 0; i < billingAccounts.billingAccountsSummary.billingAccountsSummaryElements.length; i++) {
            if (billingAccounts.billingAccountsSummary.total > 0) {
              billingInfo.rutSinDeuda = false;
            }
            if (billingAccounts.billingAccountsSummary.billingAccountsSummaryElements[i].accounts == undefined) {
              billingAccounts.billingAccountsSummary.billingAccountsSummaryElements[i].accounts = [];
            }
            if (billingAccounts.billingAccounts[k].type == billingAccounts.billingAccountsSummary.billingAccountsSummaryElements[i].type) {
              if (billingInfo.metadata.account != null && billingInfo.metadata.account != undefined && billingInfo.metadata.account != "") {
                if (billingAccounts.billingAccounts[k].id == billingInfo.metadata.account) {
                  billingInfo.cuentaConDeuda = true;
                }
              } else {
                billingInfo.cuentaConDeuda = true
              }
              if (billingAccounts.billingAccounts[k].type == "MOVIL" || (billingAccounts.billingAccounts[k].type == "MOVIL" && billingAccounts.billingAccounts[k].totalDebt > 0)) {
                billingInfo.usuarioMovil = true;
              }
              if (billingAccounts.billingAccounts[k].origen == 6 || billingAccounts.billingAccounts[k].origen == 5) {
                billingInfo.usuarioMovil = true;
              }
              if (billingAccounts.billingAccounts[k].origen == 2 && billingInfo.cuentaConDeuda && !billingInfo.metadata.payAll && billingAccounts.billingAccounts[k].id == billingInfo.metadata.account) {
                billingInfo.usuarioMovil = true;
              }
              if (billingAccounts.billingAccounts[k].origen == 1 && billingAccounts.billingAccounts[k].id && billingAccounts.billingAccounts[k].type == "HOGAR") {
                billingInfo.hogarTango = true;
              }

              if (billingAccounts.billingAccounts[k].origen == 6 && billingAccounts.billingAccounts[k].type == "PUF") {
                billingAccounts.billingAccounts[k].billingAccountBalances.forEach(element => {
                  if (element.amount > constants.minAmountPUFDevice && element.status === "Vigente") {
                    billingInfo.pufConDispositivo = true;
                  } else {
                    billingInfo.pufSinDispositivo = true;
                  }
                });
              }

              billingAccounts.billingAccountsSummary.billingAccountsSummaryElements[i].accounts.push(billingAccounts.billingAccounts[k]);
              break;
            }
          }
        }
      }
      if (state.billingInfo.muestraVencido) {
        billingInfo.muestraVencido = state.billingInfo.muestraVencido && !billingInfo.hogarTango;
      } else {
        billingInfo.muestraVencido = state.billingInfo.muestraVencido && billingAccounts.overdueTotalDebt > 0 && !billingInfo.hogarTango;
      }


      commit("updateBillingInfo", {
        billingInfo: billingInfo
      });

      let billingAccountsSummaryElements;
      if (state.billingInfo.paymentType == "express" && billingAccounts.billingAccountsSummary && billingAccounts.billingAccountsSummary.billingAccountsSummaryElements) {
        billingAccountsSummaryElements = billingAccounts.billingAccountsSummary.billingAccountsSummaryElements.map(
          (item) => {
            item.title = item.type;
            return item;
          }
        );
      } else if (billingAccounts.billingAccountsSummary && billingAccounts.billingAccountsSummary.billingAccountsSummaryElements) {
       /*    if (billingInfo.hogarTango) {
              billingAccountsSummaryElements = billingAccounts.billingAccountsSummary.billingAccountsSummaryElements.reduce(
                (arr, item) => {
                  return arr.concat(item.accounts);
                }, []
              ).filter((element) => element.type === "HOGAR").map(
                (item, index) => {
                  item.title = item.type + " " + item.id;
                  if (billingInfo.metadata != null && billingInfo.metadata.account == item.id) {
                    item.selected = true;
                    item.model = {
                      index: index,
                      selected: true
                    };
                    let itemVigente = item.billingAccountBalances.filter((element) => element.status == "Vigente");
                    
                    if (itemVigente.lenght === 0) {
                        itemVigente.push(item.billingAccountBalances[item.billingAccountBalances.lenght - 1]);
                    }
                    
                    itemVigente.amount = 0;
                    let itemNuevo = item.billingAccountBalances.reduce(function(previous, current, i) {
                        current.amount += previous.amount;
                        
                        return current;
                    }, itemVigente);
                    
                    
                    item.billingAccountBalances = [itemNuevo];
                    // item.dueTotalDebt =  itemNuevo.amount;
                    // item.overdueTotalDebt =  itemNuevo.amount;
                    
                    commit("addBillingAccount", {
                      selectedAccount: item,
                    });
                  }
                  
                  item.accounts = [{
                    id: item.id
                  }];
                  return item;
                }
              );
          } else { */
            billingAccountsSummaryElements = billingAccounts.billingAccountsSummary.billingAccountsSummaryElements.reduce(
              (arr, item) => {
                return arr.concat(item.accounts);
              }, []
            ).map(
              (item, index) => {
                item.title = item.type + " " + item.id;
                if (billingInfo.metadata != null && billingInfo.metadata.account == item.id) {
                  item.selected = true;
                  item.model = {
                    index: index,
                    selected: true
                  };
                  if (!billingInfo.metadata.flagCheck) {
                    item.billingAccountBalances = item.billingAccountBalances.filter((acct) => {
                      if (acct.status == 'Vencida') {
                        return acct;
                      }
                    });
                  }
                  commit("addBillingAccount", {
                    selectedAccount: item,
                  });
                }
                item.accounts = [{
                  id: item.id
                }];
                return item;
              }
            );
          //}
      }

      /*log.debug("Ingresando a calcular los estado", billingAccountsSummaryElements);
      //calcular los estados
      
      let deudaPUFConDispositivo = false;
      let deudaNormal = false;
      let deudaVencida = false;
      let poseeDeudaVigente = false;

      for (let item of billingAccountsSummaryElements) {
        log.debug("Item", JSON.stringify(item));
      }
      deudaPUFConDispositivo = billingAccountsSummaryElements.some(item => item.type == "PUF" && item.totalDebt > 21000); //this.pufConDispositivo;

      poseeDeudaVigente = billingAccountsSummaryElements.reduce(function(dueTotalDebt, account) {
        return dueTotalDebt + account.dueTotalDebt;
      }, 0) > 0;
      
      //verificamos si posee alguna deuda vencida
      deudaVencida = deudaVencida || (billingAccountsSummaryElements.some(account => account.overdueTotalDebt > 0) && poseeDeudaVigente);
      //si no posee deuda vencida
      deudaNormal = !deudaVencida;

      log.debug("Variables calculadas:", deudaPUFConDispositivo, poseeDeudaVigente, deudaVencida, deudaNormal);
      
      for (let item of billingAccountsSummaryElements) {
        let aux = item;

        //cuenta normal
          //seleccionamos todas las cuentas
        //cuenta vencida
          //seleccionamos las cuentas vencidas y las deshabilitamos
        //cuenta puf
          //seleccionamos las cuentas puf y deshabilitamos todas
        
        if (deudaPUFConDispositivo) {
          aux.selected = item.type == "PUF" && item.totalDebt > 0;
          aux.disabled = false;
          if ("selectedAccount" in aux) {
            aux.selectedAccount = false;
          }
          //this.$log.debug(JSON.stringify(aux));
          //console.log("En created:" + JSON.stringify(item));
        } else if (deudaVencida) {
          aux.selectedAccount = aux.overdueTotalDebt > 0;
          aux.selected = aux.dueTotalDebt > 0;
          aux.disabled = aux.dueTotalDebt == 0;
        } else if (deudaNormal) {
          aux.selected = aux.totalDebt > 0;
          aux.disabled = billingAccountsSummaryElements.length == 0;
        }
        
      }*/
      

      log.debug("BillingInfo:", JSON.stringify(billingInfo));
      log.debug("BillingAccountSummaryElements:", JSON.stringify(billingAccountsSummaryElements));

      log.debug('Mapped billing account summary element: [billingAccountsSummaryElements="', billingAccountsSummaryElements, '"]');
      commit("createBillingAccountsSummaryElements", {
        billingAccountsSummaryElements: billingAccountsSummaryElements,
      });
    }
  },
  selectBillingAccount({
    commit
  }, {
    selectedAccount
  }) {
    if (selectedAccount.selected == true) {
      commit('addBillingAccount', {
        selectedAccount
      });
    } else {
      commit('removeBillingAccount', {
        selectedAccount
      });
    }
  },
  resetBillingState({
    commit
  }) {
    commit('resetBillingState');
  }
};
const getters = {
  billingInfo(state) {
    return state.billingInfo;
  },
  curtain(state) {
    return state.curtain;
  },
  billingAccountsSummaryElements(state) {
    return state.billingAccountsSummaryElements;
  },
  selectedBillingAccountsElements(state) {
    return state.selectedBillingAccountsElements;
  },
  /**
   * Solo para SV. Componente: BillingTable.vue
   */
  selectedBillingAccountsOverdueTotal(state) {
    if (state.selectedBillingAccountsElements.length === 0) {
      state.overDueTotal = 0;
      return state.overDueTotal;
    }
    state.overDueTotal = state.selectedBillingAccountsElements.map((e) => {
      return e.overdueTotalDebt
    }).reduce((p, c) => {
      return p + c;
    });
    return state.overDueTotal;
  },
  selectedBillingAccountsDueTotal(state) {
    if (state.selectedBillingAccountsElements.length === 0) {
      return 0;
    }
    /**
     * Really bad condition TODO: do it better (we have not time!)
     */
    if (state.selectedBillingAccountsElements.length === 1 &&
      state.billingInfo.paymentType.payAll &&
      state.billingInfo.metadata.productDescription == null &&
      !state.billingInfo.metadata.totalOverdue) {
      return 0;
    }
    return state.selectedBillingAccountsElements.map((e) => {
      return e.dueTotalDebt
    }).reduce((p, c) => {
      return p + c;
    });
  },
  /**
   * Finaliza
   * Solo para SV. Componente: BillingTable.vue
   */
  selectedBillingAccountsTotal(state) {
    let amount = 0;
    for (let i = 0; i < state.selectedBillingAccountsElements.length; i++) {
      amount += state.selectedBillingAccountsElements[i].totalDebt;
    }
    return amount;
  }
}
const mutations = {
  createSelectedBillingAccountsElements(state) {
    state.selectedBillingAccountsElements = [];
  },
  createCurtainActive(state, {
    activa,
    txtError,
    tituloMigrado,
    txtMigrado,
    tituloNoMigrado,
    txtNoMigrado
  }) {
    state.curtain = {
        activa: activa,
        txtError: txtError,
        tituloMigrado: tituloMigrado,
        txtMigrado: txtMigrado,
        tituloNoMigrado: tituloNoMigrado,
        txtNoMigrado: txtNoMigrado
    };
  },
  createBillingInfo(state, {
    customerIdentificationNumber,
    email,
    paymentType,
    paymentChannel,
    context,
    homeUrl,
    muestraVencido,
    metadata
  }) {
    state.billingInfo = {
      customerIdentificationNumber: customerIdentificationNumber,
      email: email,
      paymentType: paymentType,
      paymentChannel: paymentChannel,
      context: context,
      homeUrl: homeUrl,
      muestraVencido: muestraVencido,
      metadata: metadata,
      touch: constants.touch[paymentChannel]
    };
  },
  updateBillingInfo(state, {
    billingInfo
  }) {
    state.billingInfo = {};
    state.billingInfo = billingInfo;
  },
  createBillingAccountsSummaryElements(state, {
    billingAccountsSummaryElements
  }) {
    state.billingAccountsSummaryElements = [];
    state.billingAccountsSummaryElements = billingAccountsSummaryElements;
  },
  addBillingAccount(state, {
    selectedAccount
  }) {
    if(selectedAccount){
      state.selectedBillingAccountsElements.push(selectedAccount);
    }
  },
  removeBillingAccount(state, {
    selectedAccount
  }) {
    for (let i = 0; i < state.selectedBillingAccountsElements.length; i++) {
      if (state.selectedBillingAccountsElements[i].selectedIndex == selectedAccount.selectedIndex) {
        state.selectedBillingAccountsElements.splice(i, 1);
        i--;
      }
    }
  },
  resetBillingState(currentState) {
    const s = state;
    Object.keys(s).forEach(key => {
      currentState[key] = s[key]
    })
  }
}
export {
  state,
  actions,
  getters,
  mutations,
}
